export enum ExportTypesEnum {
  DataFile,
  DataFileDetailed,
  DataFileAggregated,
}
